import { createSelector } from 'reselect';
import { PATIENT_INSURANCE_KEY } from '../constants';
import invariant from 'invariant';

const patientInsuranceSelector = createSelector(
    state => {
        invariant(
            state.hasOwnProperty(PATIENT_INSURANCE_KEY),
            `Expected the patient state to be available as \`state.${PATIENT_INSURANCE_KEY}\`. `
        );

        return state[PATIENT_INSURANCE_KEY];
    },
    insurance => insurance
);

export default patientInsuranceSelector;
